"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperSecurityChat = exports.WrapperItems = exports.WrapperChatList = exports.TitlePage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var WrapperChatList = exports.WrapperChatList = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  min-width: 376px;\n  width: 100vw;\n  @media (min-width: 840px) {\n    min-width: unset;\n    height: 100%;\n    width: 361px;\n    border-width: 0 var(--border-width-hairline) 0 0;\n    border-color: var(--color-neutral-90);\n    border-style: solid;\n    margin-top: 0;\n    overflow: hidden;\n  }\n"])));
var TitlePage = exports.TitlePage = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  font-weight: var(--font-weight-bold);\n  font-size: var(--font-size-xl);\n  color: var(--color-neutral-130);\n  margin: var(--spacing-3) var(--spacing-2) var(--spacing-2);\n"])));
var WrapperSecurityChat = exports.WrapperSecurityChat = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: var(--spacing-2);\n"])));
var WrapperItems = exports.WrapperItems = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 840px) {\n    height: 100%;\n    overflow-y: scroll;\n  }\n"])));